// extracted by mini-css-extract-plugin
export var card = "e_bh_c3";
export var cardContainer = "e_bh_c2";
export var colorBgPrimaryFive = "#612ecd";
export var colorBgPrimaryFour = "#00bcd6";
export var colorBgPrimaryOne = "#006bb2";
export var colorBgPrimarySix = "#41c91f";
export var colorBgPrimaryThree = "#d14252";
export var colorBgPrimaryTwo = "#d19b27";
export var imageContainer = "e_bh_bD";
export var layoutContainerOverride = "e_bh_cv";
export var sectionContainer = "e_bh_9";